// Offline queue via Dexie. Receipts captured offline live here until network returns.

import Dexie, { type Table } from 'dexie';
import type { Receipt } from '@nako/types';

export interface QueuedReceipt {
  local_id: string; // crypto.randomUUID()
  business_id: string;
  image_blob: Blob;
  image_hash: string; // SHA-256 of bytes
  captured_at: string; // ISO
  sync_status: 'pending' | 'syncing' | 'synced' | 'failed';
  sync_attempts: number;
  last_error?: string;
}

export interface CachedReceipt extends Receipt {
  cached_at: string;
}

class NakoDB extends Dexie {
  queuedReceipts!: Table<QueuedReceipt, string>;
  receipts!: Table<CachedReceipt, string>;

  constructor() {
    super('nako_pula');
    this.version(1).stores({
      queuedReceipts: 'local_id, sync_status, captured_at',
      receipts: 'id, business_id, receipt_date',
    });
  }
}

export const db = new NakoDB();

/** SHA-256 of a Blob as a lowercase hex string. */
export async function hashBlob(blob: Blob): Promise<string> {
  const buf = await blob.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
